import styled from 'styled-components'

export const FilterContainer = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  align-items: center;
  transition: opacity 0.3s 0.6s ease, height 0.3s 0.3s ease, visibility 0s 0s ease;
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/styles.js